import { message } from "antd";
import { axiosDelete, axiosGet, axiosPost } from "../axios";

export const postSupport = async (payload) => {
  try {
    const res = await axiosPost({
      path: "user/create-support-ticket",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getSupport = async (pageNumber, pageSize) => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosGet({
      path: `user/list-support-ticket?pageNumber=${pageNumber}&itemPerPage=${pageSize}&userId=${uId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getSupportCategory = async () => {
  try {
    const res = await axiosGet({
      path: "user/list-support-categories",
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const deleteSupportTicket = async (id) => {
  try {
    const res = await axiosDelete({
      path: `user/delete-support-ticket?id=${id?._id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const uploadScreenshot = async (payload) => {
  try {
    const res = await axiosPost({
      path: "user/upload?folder=SUPPORT",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
